import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="aboutus">
      <img src="/Aboutus.jpg" alt="Solar Panel" />
      <div className="overlay">
        <h1 className="overlay-text">About Us</h1>
      </div>
      <div className="company">
        Ecoclean Solar Solutions, a specialized solar panel cleaning company, is bringing an innovative change in addressing challenges relating to Solar Panel depletion and optimizing Power Generation by ensuring the effective cleaning and maintenance of solar panels in Pakistan.
      </div>
      <div className="story-vision-container">
        <div className="story">
          <h2 className="section-heading">Our Story</h2>
          <div className="section-content">
            <p>
              We are a solar engineering procurement & construction company working. With expertise in system designs & implementation we provide energy solutions to residential, commercial as well as industrial clients all over Pakistan. We are efficient, quality conscious and customer focused delivering turnkey solutions to bring an energy revolution in Pakistan.
            </p>
          </div>
        </div>
        <div className="section-image">
          <img src="/EcoClean.jpg" alt="Our Story and Vision" />
        </div>
        <div className="vision">
          <h2 className="section-heading">Our Vision</h2>
          <div className="section-content">
            <p>
              We are the Solar Energy Specialists driven to create an affordable and a clean energy future for residential, commercial & industrial entities in the region.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
